'use strict';

import {Hodnotenie} from './Hodnotenie';

export class HodnotenieDetail {

  id: number;
  predmetSkratka: string;
  predmetNazov: string;
  type: string;
  hodnotenia: Hodnotenie[];
}
